import { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import Crown from '@/pages/stainingStudio/crown'
import NewWashBake from '@/pages/stainingStudio/newWashbake'
import StumpShade from '@/pages/stainingStudio/stumpShade'

import LoadingSpinner from '../components/LoadingSpinner'

const StainingStudioRoutes = () => {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Routes>
        <Route path="crown" element={<Crown />} />
        <Route path="stump-shade" element={<StumpShade />} />
        <Route path="" element={<Navigate to="crown" replace={true} />} />
        <Route path="wash-bake" element={<NewWashBake />} />
      </Routes>
    </Suspense>
  )
}

export default StainingStudioRoutes
